// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const snorlax: PokeData = {
  "id": 143,
  "name": "snorlax",
  "height": 21,
  "weight": 4600,
  "base_experience": 189,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "body-slam",
    "double-edge",
    "bite",
    "hyper-beam",
    "screech",
    "harden",
    "defense-curl",
    "metronome",
    "lick",
    "amnesia",
    "rest",
    "snore",
    "flail",
    "belly-drum",
    "rollout",
    "sleep-talk",
    "crunch",
    "stockpile",
    "swallow",
    "superpower",
    "recycle",
    "yawn",
    "block",
    "covet",
    "hammer-arm",
    "fling",
    "last-resort",
    "giga-impact",
    "zen-headbutt",
    "heavy-slam",
    "chip-away",
    "bulldoze",
    "belch",
    "high-horsepower"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "body-slam",
    "bite",
    "lick",
    "crunch",
    "superpower",
    "zen-headbutt",
    "refresh",
    "tri-attack",
    "supersonic",
    "purification",
    "growl"
  ],
  "evolution_chain": {
    "id": 72,
    "item": {
      "name": "full-incense"
    },
    "species": [
      {
        "name": "munchlax",
        "order": 174,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "snorlax",
        "order": 175,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 446,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 188,
    "speed": 45,
    "ability_power": 167
  },
  "stat_changes": [],
  "catch_rate": 25,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
